import React from "react";
import PropTypes from "prop-types";
import Button from "Shared/Button";
import styles from "./ValidateAddressModal.module.css";
import AddressInfo from "components/AddressInfo";
import Modal from "components/Modal";
import { useTranslation } from "react-i18next";

export function ValidateAddressModal({
  addressInfo,
  suggestedAddress,
  onUseSuggested,
  onUseOriginal,
  onEditOriginal,
  onClose,
  isOpen,
}) {
  const {t} = useTranslation();

  return (
    <Modal isOpen={isOpen} classNames={styles.modal}>
      <div className={styles.container}>
        <h1 className={styles.title}>{t("Please Confirm Your Address")}</h1>
        <div className={styles.suggestedAddressContainer}>
          <span>{t("Suggested Address")}</span>
          {suggestedAddress && (
            <div className={styles.addressContainer}>
              <AddressInfo addressInfo={suggestedAddress} />
            </div>
          )}
          <div className={styles.modalButtons}>
            <Button
              text={t("Use Suggested Address")}
              className="selectBtn"
              onClick={onUseSuggested}
            />
          </div>
        </div>
        <div className={styles.userEnteredAddressContainer}>
          <span>{t("Original Address")}</span>
          {addressInfo && (
            <div className={styles.addressContainer}>
              <AddressInfo addressInfo={addressInfo} />
            </div>
          )}
          <div className={styles.modalButtons}>
            <Button
              text={t("Use Original Address")}
              className="editBtn"
              onClick={onUseOriginal}
            />
            <Button
              text={t("Edit")}
              className="updateBtn"
              onClick={onEditOriginal}
            />
          </div>
        </div>
        <Button className="closeBtn" text={t("Cancel")} onClick={onClose} />
      </div>
    </Modal>
  );
}

ValidateAddressModal.propTypes = {
  addressInfo: PropTypes.object,
  suggestedAddress: PropTypes.object,
  onUseSuggested: PropTypes.func.isRequired,
  onUseOriginal: PropTypes.func.isRequired,
  onEditOriginal: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
